import { render, staticRenderFns } from "./systemApprovalDetail.vue?vue&type=template&id=1fecba22&scoped=true&"
import script from "./systemApprovalDetail.vue?vue&type=script&lang=js&"
export * from "./systemApprovalDetail.vue?vue&type=script&lang=js&"
import style0 from "./systemApprovalDetail.vue?vue&type=style&index=0&id=1fecba22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fecba22",
  null
  
)

export default component.exports